import React from 'react';
import PoliciesContent from './PoliciesContent';
import { useLanguage } from '../context/LanguageContext';

const PolicyModal = ({ isOpen, onClose, initialTab = 'terms', onAccept }) => {
    const { t } = useLanguage();
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg shadow-2xl w-full max-w-3xl max-h-[88vh] flex flex-col overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
                    <div>
                        <span className="text-[11px] font-semibold uppercase tracking-widest text-[#8B6939] block">
                            Ukiyo Styling Homes
                        </span>
                        <h2 className="font-serif text-xl font-bold text-gray-800">
                            {t('storePoliciesAndTerms')}
                        </h2>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 text-2xl p-1"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>

                <div className="flex-grow overflow-y-auto p-6">
                    <PoliciesContent activeTab={initialTab} />
                </div>

                <div className="px-6 py-4 border-t bg-gray-50 flex flex-col sm:flex-row items-center justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="w-full sm:w-auto px-5 py-2.5 bg-gray-200 text-gray-800 text-sm font-semibold rounded-md hover:bg-gray-300 transition-colors"
                    >
                        {t('close')}
                    </button>
                    {onAccept && (
                        <button
                            type="button"
                            onClick={() => {
                                onAccept();
                                onClose();
                            }}
                            className="w-full sm:w-auto px-6 py-2.5 bg-[#b08d57] text-white text-sm font-semibold rounded-md hover:bg-[#9c7b4d] transition-colors shadow-sm"
                        >
                            {t('iAcceptAndAgree')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PolicyModal;
